module.exports = {
      id: "right-arrow-two-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite.svg#right-arrow-two",
      toString: function () {
        return this.url;
      }
    }